import { useRuralyticsComposable } from '~/modules/integrations/ruralytics/composables/useRuralyticsComposable'
import type { CottagePage } from '~/modules/views/cottage/entities/CottagePage'

export const usePageAnalytics = (cottagePage: CottagePage) => {
  const { sendClickedRecommended } = useRuralyticsComposable()

  sendClickedRecommended(cottagePage.id)
}
